"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePrevious = void 0;

var _react = require("react");

var usePrevious = function usePrevious(value) {
  var ref = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    ref.current = value;
  }, [value]);
  return ref.current;
};

exports.usePrevious = usePrevious;


//////////////////
// WEBPACK FOOTER
// ./js/utils/hooks/usePrevious.js
// module id = 168
// module chunks = 209 210 211 212